import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _defaultTo from 'lodash/defaultTo';
/* eslint-disable react/no-multi-comp, react/prefer-stateless-function */
import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';


import { Consumer } from '../context';
import { defaultResolver } from '../constants';

var AssetsConsumer = function (_Component) {
  _inherits(AssetsConsumer, _Component);

  function AssetsConsumer() {
    _classCallCheck(this, AssetsConsumer);

    return _possibleConstructorReturn(this, (AssetsConsumer.__proto__ || _Object$getPrototypeOf(AssetsConsumer)).apply(this, arguments));
  }

  _createClass(AssetsConsumer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        Consumer,
        null,
        function (resolver) {
          return React.createElement(
            AssetResolver,
            {
              name: _this2.props.name,
              resolver: _defaultTo(resolver, _this2.props.defaultResolver)
            },
            _this2.props.children
          );
        }
      );
    }
  }]);

  return AssetsConsumer;
}(Component);

AssetsConsumer.propTypes = {
  /** Name will be passed to resolver function provided by AssetsProvider */
  name: PropTypes.string.isRequired,
  /**
   * Function that will be called with two arguments: 'error', 'asset'.
   *
   *  @param error {Error | null} - if asset failed to resolve, 'Error' will be passed here, otherwise 'null'
   *  @param asset {React#Component | null} - asset that is returned by resolver function. If asset is not loaded yet or error occurs, it will be 'null'
   */
  children: PropTypes.func.isRequired,
  /**
   * This default is use only when there is no AssetsProvider in upper scope.
   * See 'resolver' function description in AssetsProvider's documentation.
   *
   * @returns - {React#Component | Promise}
   */
  defaultResolver: PropTypes.func
};
AssetsConsumer.defaultProps = {
  defaultResolver: defaultResolver
};
export default AssetsConsumer;

var AssetResolver = function (_PureComponent) {
  _inherits(AssetResolver, _PureComponent);

  function AssetResolver() {
    var _ref,
        _this4 = this;

    var _temp, _this3, _ret;

    _classCallCheck(this, AssetResolver);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = AssetResolver.__proto__ || _Object$getPrototypeOf(AssetResolver)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
      asset: null,
      error: null
    }, _this3.resolveAsset = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _Promise.resolve(_this3.props.resolver(name)).then(function (asset) {
                  _this3.setState({
                    asset: asset,
                    error: null
                  });
                }).catch(function (error) {
                  _this3.setState({
                    asset: null,
                    error: error
                  });
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this3, _ret);
  }

  _createClass(AssetResolver, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.resolveAsset(this.props.name);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this5 = this;

      /** Clear state when resolver or name has changed */
      if (nextProps.resolver !== this.props.resolver || nextProps.name !== this.props.name) {
        this.setState({
          asset: null,
          error: null
        }, function () {
          _this5.resolveAsset(nextProps.name);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          error = _state.error,
          asset = _state.asset;

      return this.props.children(error, asset);
    }
  }]);

  return AssetResolver;
}(PureComponent);

AssetResolver.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  resolver: PropTypes.func
};